import { Card, CardContent, CardHeader } from "@mui/material";
import type { FC } from "react";
import { AssociatedFilesEdit } from "../components/associatedFiles/AssociatedFilesEdit";
import type { FileDTO } from "./costApi";

interface Props {
  files: FileDTO[];
  onAddAttachment: (formData: FormData) => Promise<void>;
  onDeleteAttachment: (name: string) => Promise<void>;
}

const AttachmentsCard: FC<Props> = ({ files, onAddAttachment, onDeleteAttachment }) => {
  return (
    <Card>
      <CardHeader title="Załączniki" />
      <CardContent>
        <AssociatedFilesEdit
          values={files ?? []}
          onNewFile={onAddAttachment}
          onRemoveFile={async (idx) => {
            const name = files[idx].name;
            onDeleteAttachment(name);
          }}
        />
      </CardContent>
    </Card>
  );
};

export default AttachmentsCard;
